// Homeslider.js
import React from "react";
import Slider from "react-slick";
import "../Styles/homeslider.css";
import slide1 from "../../src/Images/CUSTOM-IMG-3.jpg";
import slide2 from "../../src/Images/CUSTOM-IMG-2.jpg";
import slide3 from "../../src/Images/CUSTOM-IMG-1.jpg";
import logo from "../../src/Images/E-mas-logo.png";

export default function Homeslider() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  return (
    <div className="carousel">
      <Slider {...settings}>
        <div className="slide">
          <img src={slide3} alt="Slide 3" className="slide-image" />
          <div className="slide-text right">
            <h2
              className="font-bold text-[calc(1.405rem_+_1.86vw)] carousel-txt-head"
              style={{ textAlign: "center", marginLeft: "38rem" }}
            >
              E-<span style={{ color: "#38b4fc" }}>M</span>AS
            </h2>

            <p className="carousel-Text">
              ECHS- MANAGEMENT & ADMINISTRATIVE SYSYTEM
            </p>
          </div>
        </div>

        <div className="slide">
          <img src={slide1} alt="Slide 1" className="slide-image" />
          <div className="slide-text center">
            <p
              className="font-bold text-[calc(1.405rem_+_1.86vw)]"
              style={{ marginTop: "350px" }}
            >
              We are trusted by over a million customers
            </p>
          </div>
          {/*           <div className="slide-text left ">
            <h2
              className="font-bold text-[calc(1.405rem_+_1.86vw)] carousel-txt-head"
              style={{ marginLeft: "6rem", color: "#3f78e0" }}
            >
              E-MAS
            </h2>
            <p
              className="carousel"
              style={{ marginLeft: "6rem", color: "#000" }}
            >
              ECHS MANAGEMENT & ADMINISTRATIVE SYSTEM
            </p>
          </div> */}
        </div>
        <div className="slide">
          <img src={slide2} alt="Slide 2" className="slide-image" />
          <div className="slide-text center">
            <h2 className="font-bold text-[calc(1.405rem_+_1.86vw)] carousel-txt-head">
              Just sit and relax
            </h2>
            <p className="carousel-Text">
              We make sure your spending is stress free so that <br /> you can
              have the perfect control
            </p>
          </div>
        </div>
      </Slider>
    </div>
  );
}
